import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/theme/index.css'
import Echarts from 'echarts'
import "./utils/word";
import '@/assets/css/base.css'
import vueJsonp from 'vue-jsonp'
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer)
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video
Vue.use(ElementUI)
Vue.use(vueJsonp)

// 这种方法是直接绑定在vue实例上，所以在项目中任何页面，直接 this.$echarts 即可
Vue.prototype.$echarts = Echarts
Vue.config.productionTip = false
// import { registerWorldMap } from './assets/js/registerWorldMap.js';

// registerWorldMap();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
